module.exports = __webpack_public_path__ + "static/media/Rekata_White.861f9b48.png";